import React from 'react'
import styled from 'styled-components'
import Card from 'pages/HehmDevice/HehmDashboard/Card'
import NoDataValue from 'pages/HehmDevice/HehmDashboard/NoDataValue'
import { HehmDeviceHardware } from 'types/HehmDevice'
import { LabelAndValue } from 'pages/HehmDevice/HehmDashboard/ConfigurationAndComponentsTabContent/LabelAndValue'

type Props = {
  hehmDeviceHardware: HehmDeviceHardware | null
}

const ModemCard = ({ hehmDeviceHardware }: Props) => {
  return (
    <Card
      title="Modem"
      icon="/img/modem.svg"
      iconStyle={{ marginRight: '10px' }}
    >
      <S.CardContent>
        <S.Column>
          <LabelAndValue
            label="IMEI"
            value={hehmDeviceHardware?.modem?.imei || <NoDataValue />}
          />
          <LabelAndValue
            label="ICCID"
            value={hehmDeviceHardware?.modem?.iccid || <NoDataValue />}
          />
        </S.Column>
      </S.CardContent>
    </Card>
  )
}

export default ModemCard

const S = {
  CardContent: styled.div`
    display: flex;
    gap: 70px;
  `,
  Column: styled.div`
    display: flex;
    flex-direction: column;
  `
}
